import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '../stores/auth';
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';

const routes: RouteRecordRaw[] = [
	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: { requiresAuth: false },
	},
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: { requiresAuth: true },
	},
];

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes,
});

router.beforeEach(async (to, _from, next) => {
	const authStore = useAuthStore();
	const requiresAuth = to.matched.some(
		(record) => record.meta.requiresAuth,
	);

	if (requiresAuth) {
		if (!authStore.isAuthenticated) {
			next({
				name: 'Login',
				query: { redirect: to.fullPath },
			});
		} else if (authStore.user) {
			next();
		} else {
			try {
				const isValid = await authStore.checkAuth();
				if (isValid) {
					next();
				} else {
					next({
						name: 'Login',
						query: {
							redirect: to.fullPath,
						},
					});
				}
			} catch {
				console.error(
					'Error de conexión con el servidor',
				);
				next();
			}
		}
	} else {
		if (authStore.isAuthenticated && to.name === 'Login') {
			next({ name: 'Home' });
		} else {
			next();
		}
	}
});

export default router;
